import phoneBox from "@components/loginedBunding/loginedBunding.vue";
import accountSafe from "@components/accountSafe/accountSafe.vue";
export default {
  computed: {
    router: function () {
      return this.$route.name;
    }
  },
  components: {
    phoneBox: phoneBox,
    accountSafe: accountSafe
  },
  data() {
    return {
      Phone_box: false,
      Account_safe: false,
      domain: "",
      domainBeian: this.$route.params.projectCode || this.$store.state.examInfo.currentExamInfo.domain,
    };
  },
  methods: {
    getkefu: function (id, type) {
      if (type == "live800") {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src =
          "https://live800.ata-test.net.cn/live800/chatClient/staticButton.js?companyID=228&configID=" +
          id +
          "&codeType=steady&delayload=1";
        document.getElementsByTagName("head")[0].appendChild(script);
        var script2 = document.createElement("script");
        script2.type = "text/javascript";
        script2.src =
          "https://live800.ata-test.net.cn/live800/chatClient/monitor.js?companyID=228&configID=1&codeType=custom&delayload=1";
        document.getElementsByTagName("head")[0].appendChild(script2);
        var script3 = document.createElement("script");
        script3.innerHTML =
          "function writehtml(){var temptext=StaticIcon_generate();document.getElementById('live81').innerHTML=temptext;setTimeout('write.src',9000);}setTimeout('writehtml()',1500);";
        document.getElementsByTagName("head")[0].appendChild(script3);
      } else {
        let code, link;
        let kefuInfo = id.split("+");
        if (kefuInfo.length > 1) {
          code = kefuInfo[0].toString();
          link = kefuInfo[1].toString();
        }
        //udesk
        let udeskScript = document.createElement("script");
        udeskScript.type = "text/javascript";
        udeskScript.innerHTML = `(function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.charset="utf-8";g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})(window,document,"script","https://assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");
ud({
    "code": '${code}',
    "link": '${link}',
});
`;
        document.getElementsByTagName("head")[0].appendChild(udeskScript);
      }
    },
    onPhoneBun(val) {
      this.Phone_box = val;
      this.Account_safe = true;
    },
    Accountsafe(val) {
      this.Account_safe = val;
      if (!val) {
        this.$http.get(globalProvider.serviceUrl("pc/g")).then(data => {
          if (data.body.code == resultCode.Success) {
            this.$store.commit("setCurrentUser", data.body.data);
            this.userName = data.body.data.name;
          }
        });
      }
    },
    getData: function () {
      if (this.$route.name === "main"||this.$route.name === "batch_main") {
        if (
          !this.$store.state.common.pageInfo ||
          this.$store.state.common.pageInfo.domain !=
          this.$route.params.projectCode
        ) {
          this.getInfo(this.$route.params.projectCode);
        } else {
          this.domain = this.$store.state.common.pageInfo.copy_right;
          this.getkefu(this.$store.state.common.pageInfo.online_chat, this.$store.state.common.pageInfo.chat_type);
        }
      } else {
        if (!this.$store.state.common.pageInfo) {
          this.getInfo(this.$store.state.examInfo.currentExamInfo.domain);
        } else {
          this.domain = this.$store.state.common.pageInfo.copy_right;
          this.getkefu(
            this.$store.state.common.pageInfo.online_chat,
            this.$store.state.common.pageInfo.chat_type
          );
        }
      }
    },
    getUserType() {
      if (
        this.$store.state.common.token != null &&
        this.$store.state.common.userType == null
      ) {
        this.getType();
      } else if (
        this.$store.state.common.token != null &&
        this.$store.state.common.userType != null &&
        this.$store.state.common.userType.token !=
        this.$store.state.common.token
      ) {
        this.getType();
      } else if (this.$store.state.common.token != null) {
        if (
          this.$store.state.common.userType.account_region == 1 ||
          this.$store.state.common.userType.account_region == 3
        ) {
          if (!this.$store.state.common.userType.if_bind_user) {
            this.Account_safe = true;
          }
        } else {
          this.Phone_box = true;
        }
      }
    },
    getType() {
      this.$http.get(globalProvider.serviceUrl("ea/ck/bu")).then(data => {
        if (data.body.code == resultCode.Success) {
          data.body.data.token = this.$store.state.common.token;
          this.$store.commit("setUserType", data.body.data);
          if (
            data.body.data.account_region == 1 ||
            data.body.data.account_region == 3
          ) {
            if (!data.body.data.if_bind_user) {
              this.Account_safe = true;
            }
          } else {
            this.Phone_box = true;
          }
        }
      });
    },
    getInfo: function (domain) {
      this.$http
        .get(globalProvider.serviceUrl("ea/g/pcas/{domain}"), {
          params: {
            domain: domain
          }
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            data.body.data.domain = domain;
            this.$store.commit("setPageInfo", data.body.data);
            if (!data.body.data) {
              this.domain = "";
            } else if (!data.body.data.copy_right) {
              this.domain = "";
            } else {
              this.domain = data.body.data.copy_right;
            }
            if (data.body.data) {
              if (data.body.data.online_chat) {
                this.getkefu(
                  data.body.data.online_chat,
                  data.body.data.chat_type
                );
              }
            }
          } else this.$router.push({
            name: "default.notFound"
          });
        });
    }
  },
  created: function () {
    this.getData();
    this.getUserType();
  }
};